module.exports = __WEBPACK_EXTERNAL_MODULE_213__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 213
// module chunks = 0